<template>
  <component
    :is="tag"
    class="t-text"
    :class="[
      VariantClasses[variant],
      color,
      LeadingClasses[leading],
      ClampClasses[clamp],
      SizeClasses[size],
      classes,
    ]"
  >
    <slot />
  </component>
</template>

<script setup lang="ts">
import type {
  TTextVariant,
  TTextTag,
  TTextLeading,
  TTextColor,
  TTextClamp,
  TTextSize,
} from './constants/types'
import {
  VariantClasses,
  LeadingClasses,
  ClampClasses,
  SizeClasses,
  MarginClasses,
} from './constants/constants'

export interface TText_Props {
  tag?: TTextTag
  variant?: TTextVariant
  color?: TTextColor
  leading?: TTextLeading
  clamp?: TTextClamp
  size?: TTextSize
  classes?: string
}

withDefaults(defineProps<TText_Props>(), {
  tag: 'p',
  variant: 'normal',
  color: 'text-gray-900',
  leading: 'normal',
  clamp: 'clamp0',
  size: 'base',
  classes: rawProps => {
    return MarginClasses[rawProps.size as TTextSize]
  },
})
</script>
